import {
  LayoutDashboard, Users, Network, MessageSquare, Megaphone, ShieldAlert, BookOpen,
  ClipboardList, Settings, Palette, BarChart3, Plane, Calendar,
  ListChecks, Award, BarChart2, FileText, CalendarClock, GraduationCap, LayoutTemplate, Repeat,
  Database, UserCog, ScrollText, Briefcase,
} from "lucide-react";

// Which nav route each server-side badge counter maps to, and its color tone.
export const BADGE_MAP = {
  "/messages": { key: "messages", tone: "red" },
  "/incidents": { key: "incidents", tone: "red" },
  "/announcements": { key: "announcements", tone: "yellow" },
  "/tasks": { key: "tasks_overdue", tone: "amber" },
};

export const TONE_CLASS = {
  red: "bg-[#ff3b5c] text-white shadow-[0_0_10px_rgba(255,59,92,0.55)]",
  amber: "bg-[#ffb020] text-black shadow-[0_0_10px_rgba(255,176,32,0.45)]",
  yellow: "bg-[#ffc700] text-black shadow-[0_0_10px_rgba(255,199,0,0.45)]",
};

export const NAV_SECTIONS = [
  {
    label: "Workspace",
    items: [
      { to: "/", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
      { to: "/metrics", label: "Metrics", icon: BarChart3, testid: "nav-metrics" },
    ],
  },
  {
    label: "People",
    items: [
      { to: "/directory", label: "Directory", icon: Users, testid: "nav-directory" },
      { to: "/team", label: "Team Management", icon: UserCog, testid: "nav-team", roles: ["admin", "manager"] },
      { to: "/org", label: "Org Hierarchy", icon: Network, testid: "nav-org" },
      { to: "/messages", label: "Messaging", icon: MessageSquare, testid: "nav-messages" },
      { to: "/announcements", label: "Announcements", icon: Megaphone, testid: "nav-announcements" },
    ],
  },
  {
    label: "Operations",
    items: [
      { to: "/shifts", label: "Shifts", icon: Calendar, testid: "nav-shifts" },
      { to: "/shift-swaps", label: "Shift Swaps", icon: Repeat, testid: "nav-shift-swaps" },
      { to: "/tasks", label: "Tasks", icon: ListChecks, testid: "nav-tasks" },
      { to: "/task-templates", label: "Task Templates", icon: LayoutTemplate, testid: "nav-task-templates" },
      { to: "/timeoff", label: "Time Off", icon: Plane, testid: "nav-timeoff" },
    ],
  },
  {
    label: "Culture",
    items: [
      { to: "/events", label: "Events", icon: CalendarClock, testid: "nav-events" },
      { to: "/kudos", label: "Kudos", icon: Award, testid: "nav-kudos" },
      { to: "/polls", label: "Polls", icon: BarChart2, testid: "nav-polls" },
    ],
  },
  {
    label: "Learning",
    items: [
      { to: "/knowledge", label: "Knowledge", icon: BookOpen, testid: "nav-knowledge" },
      { to: "/documents", label: "Documents", icon: FileText, testid: "nav-documents" },
      { to: "/courses", label: "Courses", icon: GraduationCap, testid: "nav-courses" },
      { to: "/onboarding", label: "Onboarding", icon: ClipboardList, testid: "nav-onboarding" },
    ],
  },
  {
    label: "Safety",
    items: [
      { to: "/incidents", label: "Incidents", icon: ShieldAlert, testid: "nav-incidents" },
    ],
  },
];

export const ADMIN_SECTION = {
  label: "Admin",
  items: [
    { to: "/admin", label: "Team Management", icon: Settings, testid: "nav-admin" },
    { to: "/positions", label: "Positions", icon: Briefcase, testid: "nav-positions" },
    { to: "/audit-log", label: "Audit Log", icon: ScrollText, testid: "nav-audit-log" },
    { to: "/branding", label: "Branding", icon: Palette, testid: "nav-branding" },
    { to: "/migrate", label: "Data Migration", icon: Database, testid: "nav-migrate" },
  ],
};
